import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { ChatPage, type ChatSearch } from "@/features/helpdesk/chat-page";
import { searchPageSchema } from "@/features/helpdesk/search-params";
import { ensureElementVisible } from "@/lib/route-guards";

// Czat apteki (`idfirm`) albo rozmowa niesparowanego adresu (`email`);
// `ticket`/`article` przewijają oś czasu do miejsca z wyszukiwarki, `back` = jej parametry.
const searchSchema = z.object({
	idfirm: z.number().int().positive().optional().catch(undefined),
	email: z.string().optional().catch(undefined),
	ticket: z.number().int().positive().optional().catch(undefined),
	article: z.number().int().positive().optional().catch(undefined),
	open: z.boolean().optional().catch(undefined),
	back: searchPageSchema.optional().catch(undefined),
});

export const Route = createFileRoute("/_auth/helpdesk/czat")({
	// Ten sam element co skrzynka — czat jest częścią „Obsługi”.
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(context.queryClient, "sidebar.helpdesk.obsluga", location.pathname);
	},
	validateSearch: (search: Record<string, unknown>): ChatSearch => searchSchema.parse(search),
	component: ChatRoute,
});

function ChatRoute() {
	return <ChatPage search={Route.useSearch()} />;
}
